import { useMemo } from 'react';

const scoreMap: Record<string, number> = {
  low: 1,
  moderate: 2,
  high: 3,
};

interface HookProps {
  value: string;
}

export const useLimraIcon = (props: HookProps) => {
  const { value } = props;
  const total = 3;
  const score = useMemo(() => scoreMap[value] ?? 0, [value]);

  return { total, score };
};
